module.exports = __webpack_public_path__ + "img/病人头像@3x.2d94b45c.png";